import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "evrideo-headphones-icon",
  templateUrl: "./headphones-icon.component.html",
  styleUrl: "./headphones-icon.component.scss",
})
export class HeadphonesIconComponent implements OnChanges {
  private _muted: boolean = true;

  @Input("strokeColor") strokeColor: string = "#2DBBFC";
  @Input("fillColor") fillColor: string = "#2DBBFC";
  /** When set from outside (e.g. channel.previewListenMuted), the icon reflects this state. */
  @Input() set muted(value: boolean) {
    if (value !== undefined && value !== null) {
      this._muted = value;
    }
  }
  @Output() mutedChange = new EventEmitter<boolean>();
  public _offColor = "#757575";

  get muted(): boolean {
    return this._muted;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["muted"] && changes["muted"].currentValue !== undefined) {
      this._muted = !!changes["muted"].currentValue;
    }
  }

  onHeadphonesClick(): void {
    this._muted = !this._muted;
    this.mutedChange.emit(this._muted);
  }
}
